import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { Store, select } from "@ngrx/store";

import * as fromStore from "../store";
import * as fromModels from "../models";

// QSL-9973 (Admin Nav Phase 5): all admin-tier roles share a single
// /super-admin/* URL tree. The role-specific shells (/crm, /engineer,
// /reviewer) were removed in this phase; their NAV_REGISTRY entries
// already gate what each role sees inside /super-admin/*.
const ADMIN_TIER_ROLES = ["OWNER", "ADMIN", "CRM", "REVIEWER", "ENGINEER"];

@Injectable({
  providedIn: "root",
})
export class SuperAdminGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store<fromStore.IRootState>
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.store.pipe(
      select(fromStore.getCurrentUser),
      filter((user: fromModels.IUser) => !!user),
      map((user: fromModels.IUser) => {
        const roleType = user?.organizations[0]?.role?.type;
        if (user?.isEmailVerified || roleType === "MEMBER") {
          if (ADMIN_TIER_ROLES.includes(roleType)) {
            return true;
          } else if (roleType === "TEACHER") {
            this.router.navigate(["/teacher"]);
            return false;
          } else if (roleType === "MEMBER") {
            this.router.navigate(["/member"], {
              queryParams: { action: "login" },
            });
            return false;
          }
        } else {
          this.router.navigate(["/auth/signup"]);
          return false;
        }
      })
    );
  }
}
